export type StoreBrand = 'yassir' | 'kool' | 'unattributed'

/**
 * Resolves the backend brand slug into a display brand.
 * Legacy / empty / null orders resolve to "unattributed" (a neutral label,
 * NOT Yassir). Only an exact "kool" / "yassir" slug maps to that brand.
 */
export const resolveStoreBrand = (brand?: string | null): StoreBrand => {
  const normalized = brand?.trim().toLowerCase()

  if (normalized === 'kool') return 'kool'
  if (normalized === 'yassir') return 'yassir'

  return 'unattributed'
}

/** i18n keys for each resolved brand's user-facing label. */
export const STORE_BRAND_LABEL_KEYS: Record<StoreBrand, string> = {
  yassir: 'orders.brand-yassir',
  kool: 'orders.brand-kool',
  unattributed: 'orders.brand-unattributed'
}

/**
 * Single-select brand filter options. An empty value means "all brands"
 * (no brand filter). "unattributed" is intentionally not an option: it is a
 * display label only and is excluded from brand-specific filtered views.
 */
export const STORE_BRAND_FILTER_OPTIONS: { value: string; labelKey: string }[] =
  [
    { value: '', labelKey: 'orders.brand-all' },
    { value: 'kool', labelKey: 'orders.brand-kool' },
    { value: 'yassir', labelKey: 'orders.brand-yassir' }
  ]
